import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {Container, Typography, Box} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useStyles } from './SaleTimerBannerStyles';
import { withNamespaces, Trans } from 'react-i18next';
import phones from '../../assets/images/banner_phone.png';
import bfGift from '../../assets/images/banner_black_friday.png';
import cmGift from '../../assets/images/banner_cyber_monday.png';
import clsx  from 'clsx';

function SaleTimerBanner({
	t, 
	classes, 
	price, 
	planConfig,
	onClickBanner
}) {
	const _time = 1750; //moment('2023-11-17T09:00:00.000').diff(moment(), 'seconds');
	const [seconds, onUpdateSeconds] = useState(_time);
	let intervalId = -1;

	const convertSecondsToReadableString = (seconds) => {
		const _s = (seconds > 0) ? seconds : 0;
		const d = Math.floor(_s / (3600 * 24));
		const h = Math.floor(_s % (3600 * 24) / 3600);
		const m = Math.floor(_s % 3600 / 60);
		const s = Math.floor(_s % 60);

		return {d, h, m, s};
	};

	useEffect(() => {
		intervalId = setInterval(() => {
			onUpdateSeconds(prevTime => prevTime - 1);
		}, 1000);

		return () => clearInterval(intervalId);
	}, []);

	const dateArray = convertSecondsToReadableString(seconds);
	const _hours = dateArray.h;
	const _miuntes = dateArray.m;
	const _seconds = dateArray.s;
	const isCM = planConfig?.saleTimerVariant === 'cyberMonday';
	const isBF = planConfig?.saleTimerVariant === 'blackFriday' || isCM;

	return (
		<div className={clsx(classes.saleTimerBanner,{[classes[planConfig?.saleTimerBgClassName]]: planConfig?.saleTimerBgClassName, [classes.bfBanner]: isBF, [classes.cmBanner]: isCM})} onClick={onClickBanner}>
			<Container component="div" className={clsx(classes.saleTimerBannerContainer, {[classes.bfContainer]: isBF})}>
				<Box display="flex" alignItems="center" className={clsx(classes.saleTimerBannerText, {[classes.bfText]: isBF})}>
					<img src={isCM ? cmGift : isBF ? bfGift : phones} alt="" className={isBF ? classes.bfGift : classes.saleTimerBannerPhones} />
					<span>
						{planConfig?.saleTimerEyebrow ? <span className={clsx(classes.bfEyebrow, {[classes.cmEyebrow]: isCM})}>{t(planConfig.saleTimerEyebrow)}</span> : null}
						{planConfig?.saleTimerTitle ? 
							<span>
								<span className={isBF ? clsx(classes.bfPrice, {[classes.cmPrice]: isCM}) : classes.textGreen}>{price}</span> {isBF ? null : <br/>}{t(planConfig?.saleTimerTitle)}
							</span> : 
							planConfig?.saleTimerTitleArray ?
								<span>
									<span className={classes.textGreen}>{price}</span> <br/>
									{planConfig?.saleTimerTitleArray.map(p => <span key={p}>{t(p)}<br/></span>)}
								</span> :
								<Trans i18nKey="transHs">
									<span className={classes.textGreen}>{{transHsPrice: price}}</span> Holiday <br/>VPN Deal!
								</Trans>
						}
					</span>
				</Box>
				{seconds > 0 ?
					<Typography component="div" className={clsx(classes.saleTimerBannerClock, {[classes.bfClock]: isBF})}>
						<Box className={classes.saleTimerBannerClockItem}>
							<span>{(_hours < 10 ? '0': '') + _hours}</span>
							<span className={classes.saleTimerBannerClockItemText}>{t('HOUR' + (_hours > 1 ? 'S' : ''))}</span>
						</Box>
						<Box className={classes.saleTimerBannerClockItemSeparator}>:</Box>
						<Box className={classes.saleTimerBannerClockItem}>
							<span>{(_miuntes < 10 ? '0': '') + _miuntes}</span>
							<span className={classes.saleTimerBannerClockItemText}>{t('MINUTE' + (_miuntes > 1 ? 'S' : ''))}</span>
						</Box>
						<Box className={classes.saleTimerBannerClockItemSeparator}>:</Box>
						<Box className={classes.saleTimerBannerClockItem}>
							<span>{(_seconds < 10 ? '0': '') + _seconds}</span>
							<span className={classes.saleTimerBannerClockItemText}>{t('SECOND' + (_seconds > 1 ? 'S' : ''))}</span>
						</Box>
					</Typography>:null
				}
				<Typography component="div" className={clsx(classes.saleTimerBannerCTA, {[classes.bfCTA]: isBF})}>
					<span>{t('Get Deal')}</span>
				</Typography>
			</Container>
		</div>
	);
}

SaleTimerBanner.propTypes = {
	classes: PropTypes.object,
	price: PropTypes.string,
	planConfig: PropTypes.object,
	onClickBanner: PropTypes.func,
	t: PropTypes.func
};

export default withStyles(useStyles)(withNamespaces()(SaleTimerBanner));